export async function getAllDataFromAirtable(url, apiKey, searchString, project) {
  let param = '';
  let finalResponse = [];
  if (searchString) {
    param = `?filterByFormula=(AND(FIND(%22${project}%22%2C+%7Bprojects%7D+%26+'')%2COR(SEARCH(LOWER("${searchString.trim()}")%2C+LOWER(%7Btitle%7D))%2CSEARCH(LOWER("${searchString.trim()}")%2C+LOWER(%7Bdescription%7D)))))`
  } else {
    param = `?filterByFormula=(FIND%28%22${project}%22%2C%20%7Bprojects%7D%20%26%20%27%27%29)`;
  }
  await fetch(`${url}${param}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  })
    .then((response) => response.json())
    .then((response) => {
      // Format the data that is coming from airtable and change it to be an array of items
      response.records.map((item) => finalResponse.push(item?.fields));
    })
    .catch((error) => console.error(error));
  return finalResponse;
}

export async function getIndividialDataFromAirtable(url, apiKey, itemId) {
  let airtableResponse;
  await fetch(`${url}/${itemId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  })
    .then((response) => response.json())
    .then((response) => (airtableResponse = response))
    .catch((error) => console.error(error));
  return airtableResponse?.fields;
}
